export enum GlobalText {
	HeadingYourAnswer = "9041A4A7-C720-4DCA-8757-858A700F3BCD",
	HeadingCorrectAnswer = "FF87E43E-A858-4882-8006-1742C55D30DF",
	ButtonSubmit = "0CD54AA6-C7E1-4841-9F5E-CBA3A0D3695A",
}
